module.exports = __webpack_public_path__ + "static/img/aboutUs19.70039c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs19.jpg
// module id = 1371
// module chunks = 1